export const env = {
	mode: import.meta.env.VITE_MODE,
	DRYP_API_URL: import.meta.env.VITE_DRYP_API_URL,
	RAIN_API_URL: import.meta.env.VITE_RAIN_API_URL,
	SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
	MAINTENANCE_MODE: import.meta.env.VITE_MAINTENANCE_MODE === "true",
	ENTRA_SSO_LOGIN_URL: import.meta.env.VITE_ENTRA_SSO_LOGIN_URL,
	MIXPANEL_TOKEN: import.meta.env.VITE_MIXPANEL_TOKEN,
	MAPBOX_TOKEN: import.meta.env.VITE_MAPBOX_TOKEN,
};
